export default __webpack_public_path__ + "static/media/developer 5.732d26a8.jpg";